import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

/** AG-Grid CSV table view. Pagination beyond the first 500 rows lands in M2. */
export default function CSVViewer(props: {
  columns: string[];
  rows: unknown[][];
  total: number;
}) {
  const colDefs = props.columns.map((name) => ({
    field: name,
    headerName: name,
    sortable: true,
    resizable: true,
  }));
  const rowData = props.rows.map((r) =>
    Object.fromEntries(props.columns.map((c, i) => [c, r[i]])),
  );
  return (
    <div className="ag-theme-quartz h-full">
      {props.total > props.rows.length && (
        <div className="border-b border-ink-200 bg-ink-100 px-3 py-1 text-xs text-ink-500">
          Showing {props.rows.length} of {props.total} rows
        </div>
      )}
      <AgGridReact rowData={rowData} columnDefs={colDefs} animateRows={false} />
    </div>
  );
}
